import ModalAlert from './ModalAlert';

export default ModalAlert;